import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { X } from 'lucide-react';

/** Full-screen view of one image; pinch to zoom, tap outside or X to close */
const ImageLightbox = ({ image, onClose }) => {
  useEffect(() => {
    if (!image) return undefined;
    const onKey = (e) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [image, onClose]);
  if (!image) return null;
  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-50 bg-black/90 flex flex-col animate-fadeIn" onClick={onClose}>
      <div className="flex items-center justify-between p-3 text-white/80">
        <span className="text-sm truncate pr-3">{image.alt}</span>
        <button onClick={onClose} aria-label="Close" className="p-2 rounded-full hover:bg-white/10"><X size={22} /></button>
      </div>
      <div className="flex-1 overflow-auto flex items-center justify-center p-2" style={{ touchAction: 'pinch-zoom' }}>
        <img src={image.src} alt={image.alt} className="max-w-full max-h-full object-contain" onClick={(e) => e.stopPropagation()} />
      </div>
    </div>,
    document.body
  );
};

/** A screenshot that opens in the lightbox when tapped */
export const ZoomableImage = ({ src, alt, caption, onZoom }) => (
  <figure className="space-y-2">
    <button type="button" onClick={() => onZoom({ src, alt })} className="block w-full" aria-label={`Enlarge: ${alt}`}>
      <img src={src} alt={alt} className="w-full rounded-lg border border-gray-200 dark:border-gray-600" />
    </button>
    {caption && <figcaption className="text-xs text-gray-500 dark:text-gray-400 text-center">{caption}</figcaption>}
  </figure>
);

export default ImageLightbox;
